<template>
  <div class="graph-legend d-flex align-center mb-2">
    <span class="legend-color" :style="`background:${color}`"></span>
    <span class="legend-value"
      >{{ value ? value.toFixed(1) : 0 }}<span class="percentage">%</span></span
    >
    <span class="legend-label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "graphLegend",
  props: {
    label: {
      type: String,
      default: () => {
        return "";
      },
    },
    value: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    color: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
};
</script>

<style scoped lang="scss">
.legend-color {
  height: 24px;
  width: 24px;
  max-width: 24px;
  border: 2px solid white;
  border-radius: 9px;
  background: #3966ff;
  box-shadow: 0 2px 4px 0 rgba(68, 68, 79, 0.15);
}
.legend-value {
  margin-left: 25px;
  font-size: 33px;
  font-weight: bold;
  .percentage {
    font-size: 19px;
  }
}
.legend-label {
  margin-left: 25px;
  font-weight: bold;
  font-size: 14px;
}
.d-flex > * {
  flex: initial !important;
}
</style>
